import { render, staticRenderFns } from "./mokuai23.vue?vue&type=template&id=3b63accd&"
import script from "./mokuai23.vue?vue&type=script&lang=js&"
export * from "./mokuai23.vue?vue&type=script&lang=js&"
import style0 from "./mokuai23.vue?vue&type=style&index=0&id=3b63accd&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports